import { forwardRef, type ReactNode, type ComponentProps, type Ref } from 'react';

import { Text, Anchor, Icon } from '@sso/shared/core';
import { boxed } from '@sso/shared/hocs';

type NavigationLinkProps = ComponentProps<typeof Anchor> & {
    before?: ReactNode;
    after?: ReactNode;
    isReturnBack?: boolean;
};

function NavigationLink(
    {
        isReturnBack,
        className,
        children,
        before,
        after,

        ...anchorProps
    }: NavigationLinkProps,
    ref: Ref<HTMLAnchorElement>,
) {
    return (
        <Text color="neutral.subtitle" size="textMd" as="p" className={className}>
            {before}
            {before && ' '}
            <Anchor {...anchorProps} ref={ref}>
                {isReturnBack && <Icon name="arrow-left" mr={4} />}
                {children}
            </Anchor>
            {after && ' '}
            {after}
        </Text>
    );
}

export default boxed(forwardRef(NavigationLink));
